import { GetVINReelsParams } from './useVINReelsQuery';
const BASE_KEY = 'VINREELS';

export const VINReelsKeys = {
  all: () => [BASE_KEY] as const,
  list: (params: GetVINReelsParams) => [BASE_KEY, params],
};
